import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsRoutingModule } from './settings-routing.module';
import { AppMaterialModule } from '../app-material/app-material.module';
import { FormsModule } from '@angular/forms';
import { GeneralSettingsComponent } from './general-settings/general-settings.component';
import { ChangepassowrdComponent } from './changepassowrd/changepassowrd.component';
import { QuillModule } from 'ngx-quill';
import { UpdateOrgComponent } from './update-org/update-org.component';
import { RestartDialogComponent } from './restart-dialog/restart-dialog.component';
import { UserDialogComponent } from './user-dialog/user-dialog.component';

@NgModule({
  declarations: [GeneralSettingsComponent, ChangepassowrdComponent, UpdateOrgComponent, RestartDialogComponent, UserDialogComponent],
  entryComponents: [UserDialogComponent],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    AppMaterialModule,
    FormsModule,
    QuillModule
  ]
})
export class SettingsModule { }
